<ion-card 
  class="notification-card" 
  (click)="navigateTo('/rider-dashboard')" 
  router-direction="forward" 
  *ngIf="potentialRiderJob?.jobStatus === JobStatus.JOB_CREATED">
  
  <ion-card-content class="notification-content">
    <ion-icon name="notifications" class="notification-icon"></ion-icon>
    <div class="notification-text">
      <h2>You have a new Job!</h2>
      <p>Click here to check details</p>
    </div>
  </ion-card-content>
</ion-card>

